import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { AdminConfService } from '@/shared/services/admin-conf/admin-conf.service';
import { ConfigType } from '@/pages/Admin/Configuration/model/Config.model';

@Module({
  namespaced: true,
  name: 'config'
})
export default class ConfigModule extends VuexModule {
  loading = false;
  configDivisions = null;
  configPool = null;
  configSize = null;
  configType = null;
  configSSl = null;

  @Mutation
  public SET_LOADING_STATUS(loading: boolean) {
    this.loading = loading;
  }

  @Mutation
  public SET_CONFIG_DIVISIONS(payload) {
    this.configDivisions = payload ? { ...payload } : null;
  }

  @Mutation
  public SET_CONFIG_POOL(payload) {
    this.configPool = payload ? { ...payload } : null;
  }

  @Mutation
  public SET_CONFIG_SIZE(payload) {
    this.configSize = payload ? [...payload] : null;
  }

  @Mutation
  public SET_CONFIG_TYPE(payload) {
    this.configType = payload ? [...payload] : null;
  }

  @Mutation
  public SET_CONFIG_SSL(payload) {
    this.configSSl = payload ? { ...payload } : null;
  }

  @Action
  async getConfigDivisions(payload) {
    // TODO work with admin service
  }

  @Action
  async getConfigPool(payload) {
    // TODO work with admin service
  }

  @Action
  async getConfigSize() {
    const sizeList = await AdminConfService.getData(ConfigType.SIZE);
    if (sizeList.length) {
      this.context.commit('SET_CONFIG_SIZE', sizeList);
    }
  }

  @Action
  async getConfigType() {
    const typeList = await AdminConfService.getData(ConfigType.TYPE);
    if (typeList.length) {
      this.context.commit('SET_CONFIG_TYPE', typeList);
    }
  }

  @Action
  async getConfigSSL(payload) {
    // TODO work with admin service
  }
}
